export default __webpack_public_path__ + "static/media/office_web-lg@1x.a1110119.webp";